<template>
    <div class="z-50 inline-block text-left" @mouseleave="close()">
        <div>
            <button type="button"
                @mouseover="open()"
                :class="['flex items-center', togglerClass, isOpen ? 'dropdown-open' : '']"
            >
                <slot name="toggler" />
                <chevron-down-icon class="block stroke-white high-contrast:stroke-black" width="10" height="7" alt="toggler"></chevron-down-icon>
            </button>
        </div>
        <div
            v-if="isOpen"
            class="absolute left-0 z-50 mt-2 origin-top-left"
            :class="contentClass"
        >
            <slot name="content" />
        </div>
    </div>
</template>

<script>
import ChevronDownIcon from "./Icons/ChevronDown.vue";

export default {
    components: { ChevronDownIcon },
    props: {
        togglerClass: {
            type: String|Array,
            required: false,
            default: "",
        },
        contentClass: {
            type: String,
            required: false,
            default: "",
        }
    },
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        open() {
            this.isOpen = true;
            this.$emit('open');
        },
        close() {
            this.isOpen = false;
            this.$emit('close');
        }
    }
};
</script>